module.exports = __webpack_public_path__ + "static/media/4-a.916f0a06.jpg";